import { render, staticRenderFns } from "./ProductItemModal.vue?vue&type=template&id=0a116830&scoped=true"
import script from "./ProductItemModal.vue?vue&type=script&lang=js"
export * from "./ProductItemModal.vue?vue&type=script&lang=js"
import style0 from "./ProductItemModal.vue?vue&type=style&index=0&id=0a116830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a116830",
  null
  
)

export default component.exports